import React from "react";
import { isSet } from "../../../../../../utils/commonUtils";

const YesAnswersDisplay = ({
    list = [],
    formData = {},
    col = 'col-12',
    label = 'Do you have or have you ever had'
}) => {
    // Filter list to show only items with "Yes" value
    const yesAnswers = list.filter(item => {
        const value = isSet(formData[item.name], '');
        return value === 'Yes' || value === 1 || value === '1';
    });

    if (yesAnswers.length === 0) {
        return (
            <div className={`${col}`}>
                <div className="card sh_basecard border-0 shadow-none h-auto mb-0">
                    {/* <div className="card-header p-2">
                        <h6 className="fw-semibold m-0 text-dark text-md">{label}</h6>
                    </div> */}
                    <div className="card-body">
                        <p className="text-muted mb-0">No conditions selected as "Yes"</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={`${col}`}>
            <div className="card sh_basecard border-0 shadow-none h-auto mb-0">
                {/* <div className="card-header p-2">
                    <h6 className="fw-semibold m-0 text-dark text-md">{label}</h6>
                </div> */}
                <div className="card-body">
                    <div className="row">
                        {yesAnswers.map((item, index) => (
                            <div className="col-12 mb-2" key={index}>
                                <div className="d-flex align-items-center justify-content-between">
                                    <span className="text-sm text-dark ">{item.label}</span>
                                    <span className="badge badge-success ml-2">Yes</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default YesAnswersDisplay;

